import React from 'react';
import { Gift, ChevronLeft, Construction } from 'lucide-react';
import { Button } from '../ui/button';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Rewards = () => {
  const { t } = useTranslation();
  
  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100dvh-4rem)] p-6">
      <div className="w-full max-w-md flex flex-col items-center text-center space-y-8">
        {/* Icon */}
        <div className="relative">
          <div className="h-24 w-24 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
            <Gift className="h-12 w-12 text-blue-600 dark:text-blue-400" />
          </div>
          <div className="absolute -right-2 -top-2 h-10 w-10 rounded-full bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center">
            <Construction className="h-5 w-5 text-amber-600" />
          </div>
        </div>
        
        {/* Text content */}
        <div className="space-y-4">
          <h1 className="text-3xl font-bold tracking-tight">{t('rewards.title')}</h1>
          <p className="text-muted-foreground text-lg">
            {t('rewards.comingSoon')}
          </p>
          <p className="text-muted-foreground">
            {t('rewards.description')}
          </p>
        </div>
        
        {/* Return button */}
        <Link to="/leaderboard">
          <Button className="gap-2">
            <ChevronLeft className="h-4 w-4" />
            {t('rewards.backToLeaderboard')}
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default Rewards;